var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoTicketsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08594 16.5584H14.4776C17.5609 16.5584 18.3276 15.7917 18.3276 12.7084C17.2609 12.7084 16.4026 11.8417 16.4026 10.7834C16.4026 9.71673 17.2609 8.85006 18.3276 8.85006V8.0834C18.3276 5.00006 17.5609 4.2334 14.4776 4.2334H9.16094V9.89173",
    stroke: "#14141F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16065 14.0583V16.5583H6.85232C5.61899 16.5583 4.89399 15.7166 4.09399 13.7833L3.94399 13.4083C4.95232 13.0083 5.44399 11.8416 5.01899 10.8333C4.61065 9.82492 3.45232 9.34159 2.43565 9.75825L2.29399 9.39992C1.09399 6.46659 1.51065 5.44159 4.44399 4.23325L6.64399 3.33325L9.16065 9.43325V11.5583",
    stroke: "#14141F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80182 16.5583H6.66016",
    stroke: "#14141F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoTicketsActive);
export default __webpack_public_path__ + "static/media/trvto_ticketsActive.0b657c214d36fd511fb2b3d3875cf878.svg";
export { ForwardRef as ReactComponent };